import { render, staticRenderFns } from "./IconChevronRight.vue?vue&type=template&id=1ae8dcf6&scoped=true&"
import script from "./IconChevronRight.vue?vue&type=script&lang=js&"
export * from "./IconChevronRight.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ae8dcf6",
  null
  
)

export default component.exports